export default function LoadingSherpaProjectsPage() {
  return (
    <>
      <div className="animate-pulse">
        <section className="border-b border-neutralColor-light pb-5">
          <div className="h-10 w-36 bg-neutralColor-light rounded-md"></div>
        </section>
        <section className="h-36 w-full bg-neutralColor-light rounded-md my-5"></section>
        <section className="grid grid-cols-1 lg:grid-cols-4 md:grid-cols-3 gap-5">
          {[0, 0, 0, 0, 0, 0, 0, 0].map((_, i) => (
            <div key={i} className="my-2 w-auto shadow-md rounded-md relative">
              <div className="bg-neutralColor-light h-64 w-full"></div>
              <div className="p-2 bg-white">
                <div className="h-4 bg-neutralColor-light rounded w-1/4 my-2"></div>
                <div className="space-y-2">
                  <div className="h-4 bg-neutralColor-light rounded mb-2"></div>
                </div>
                <div className="space-y-2">
                  <div className="h-4 bg-neutralColor-light rounded w-2/3 mb-2"></div>
                </div>
              </div>
            </div>
          ))}
        </section>
      </div>
    </>
  );
}
